import React from 'react';

const TableContext = React.createContext({
	handleAffectedColChanges: () => {},
	setColTypeAndEditingState: () => {},
	setPlaceholder: () => {},
});

export default TableContext;
